import React from "react";
import { Link } from "react-router-dom";
import { BsBookmarkPlus } from "react-icons/bs";
import useAuthContext from "./AuthContext/AuthContext";

const Movie = ({ movie }) => {
  const { handleFilter } = useAuthContext();

  const handleCart = (id) => {
    handleFilter(id);
  };

  return (
    <>
      <div className="border border-border p-1 hover:scale-95 transitions relative rounded overflow-hidden">
        <Link to={`/movies/${movie?.name}`} className="w-full">
          <img
            src={`${movie?.image}`}
            alt={movie?.name}
            className="w-full h-64 object-cover"
          />
        </Link>

        <div className="absolute flex-btn gap-28 bottom-0 right-0 left-0 bg-main bg-opacity-60 text-white px-4 py-3">
          <h3 className="font-semibold truncate">{movie?.name}</h3>
          <button
            onClick={() => handleCart(movie.id)}
            className="h-6 w-6 text-sm flex-colo transitions hover:bg-transparent border-2 border-subMain rounded-md bg-subMain text-white font-bold"
          >
            <BsBookmarkPlus />
          </button>
        </div>
      </div>
    </>
  );
};

export default Movie;
